import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d6fbb8a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainContainer: require('/home/nuxt/deploy/pixchannel-2022/components/main/mainContaner/MainContainer.vue').default})
